import React from "react";
import Footer from "../components/Layout/Footer";
import Header from "../components/Layout/Header";
import styles from "../styles/styles";

const CustomEnquiry = () => {
  return (
    <div>
      <Header activeHeading={5} />
      <div className="w-full flex justify-center">
        <div className="w-[95%] sm:w-[90%] md:w-[80%] lg:w-[60%] my-10">
          <Enquiry />
        </div>
      </div>
      <Footer />
    </div>
  );
};

const Enquiry = () => {
  return (
    <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg w-full">
      <h1 className="text-[20px] sm:text-[27px] text-center sm:text-start font-semibold mb-4">
        Enterprise / SEZ / Custom Purchase
      </h1>
      <p className="text-[14px] sm:text-[18px] text-center sm:text-start text-[#333] mb-4">
        Please contact us at{" "}
        <a href="mailto:custom_sales@hawler.co.in" className="text-blue-500 underline">
          sales@hawler.co.in
        </a>
      </p>
      <p className="text-[14px] sm:text-[16px] text-center sm:text-start text-[#555] mb-4">
        For standard parts ordering, kindly mention the product ID metioned in our product page, name, description, and quantity in your Purchase Order (PO) or Request for Quotation (RFQ).
      </p>
      <p className="text-[14px] sm:text-[16px] text-center sm:text-start text-[#555]">
        For custom manufacturing solutions, please email your complete requirement details. We will source the correct products from the right suppliers.
      </p>
    </div>
  );
};

export default CustomEnquiry;


